<template lang="pug">

    form.ui.form(v-on:submit.prevent='submit()')

        step-indicator(v-bind:activeStep='2')

        add-variant-navigation(
            v-bind:activeVariantNumber='activeVariantNumber'
            v-model='variants'
            v-on:change='setActiveVariant($event)'
        )

        .ui.top.attached.header Allgemeine Angaben:
        .ui.bottom.attached.segment
            general-information-form(
                ref="generalInformation"
                v-bind:company='company'
                v-model='model'
            )

        .ui.top.attached.header Auflage:
        .ui.bottom.attached.segment
            printings-form(v-model='activeVariant' ref="printingsForm")

        .ui.top.attached.header Angaben für {{ fieldSetModel.name }}:
        .ui.bottom.attached.segment
            variant-form(
                ref="variantForm"
                v-bind:form-model="formModel"
                v-model="activeVariant"
            )

        .ui.top.attached.header Skizzen:
        .ui.bottom.attached.segment
            p.ui.info.message Hier haben sie die Möglichkeit eine Voransicht oder Skizze Ihrer Anfrage hochzuladen. Diese kann von den Anbietern eingesehen werden. Sie dient ausschließlich zur Information bzw. Verdeutlichung und nicht als Druckvorlage.
            thumbnails(
                v-bind:actions="['delete']"
                v-bind:file-models="fileModels"
                v-bind:hide-details="true"
                v-bind:product-file-models="model.files"
                v-bind:product-model="model"
            )
            dropzone(v-on:uploaded="onUploaded")

        wizard-navigation(v-on:back="back()")

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import GeneralInformationForm from '@/components/products/forms/GeneralInformationForm.vue'
    import AddVariantNavigation from '@/components/products/AddVariantNavigation.vue'
    import Dropzone from '@/components/app/Dropzone'
    import PrintingsForm from '@/components/products/forms/PrintingsForm.vue'
    import StepIndicator from '@/components/products/StepIndicator.vue'
    import Thumbnails from '@/components/products/files/Thumbnails'
    import VariantForm from '@/components/products/forms/VariantForm.vue'
    import WizardNavigation from '@/components/products/WizardNavigation.vue'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        async beforeRouteEnter(to, from, next) {
            if (store.getters['products/draft'].type === undefined) {
                next({ name: 'products/create' })
            }

            // Forms-ID holen
            const id = to.params.key

            await Promise.all([

                // Wenn ID des Unternehmens gueltig ist, dann Unternehmen laden
                R.when(R.is(Number),
                    id => store.dispatch('companies/loadOne', { id }),
                )(store.getters['products/draft'].company),

                // Formulare laden
                store.dispatch('forms/loadOne', { id })

            ]).then(next)

            next()
        },

        components: {
            AddVariantNavigation, Dropzone, GeneralInformationForm, PrintingsForm, StepIndicator, Thumbnails,
            VariantForm, WizardNavigation
        },

        computed: {

            activeVariant: {
                get() { return this.variants.find(variant => variant.number === this.activeVariantNumber )},
                set(value) {
                    // Varianten kopieren
                    const variants = [ ...this.variants ]

                    // Index der neuen Varianten finden
                    const index    = this.variants.findIndex(variant => variant.number === value.number)

                    // Neue Variante setzen
                    variants[index] = value
                    this.variants = variants
                }
            },

            company() {
                return R.ifElse(

                    // Pruefen ob ID des Unternehmens gueltig ist
                    R.is(Number),

                    // Unternehmen holen
                    store.getters['companies/byId'],

                    // Ansonsten leeres Objekt zurueckgeben
                    R.always({})

                )(this.model.company)
            },

            fileModels() {
                return R.compose(

                    // Files holen
                    R.map(this.$store.getters['files/byId']),

                    // IDs auslesen
                    R.map(R.prop('file'))

                )(this.model.files)
            },

            formModel() {
                // Forms-ID holen
                const id = this.$route.params.key

                // Forms holen
                return store.getters['forms/byId'](id)
            },

            fieldSetModel() {
                const fm = this.formModel
                return (fm && fm.fieldSets && fm.fieldSets.length) ? fm.fieldSets[0] : {}
            },

            isInvalid() {
                return this.$refs.generalInformation.$v.$invalid ||
                    this.$refs.printingsForm.$v.$invalid ||
                    this.$refs.variantForm.$invalid

            },

            model: {
                get() { return this.$store.getters['products/draft'] },
                set(value) { this.$store.commit('products/REPLACE_DRAFT', { draft: value }) }
            },

            productFileModels: {
                get() { return R.propOr([], 'files', this.model) },
                set(value) { this.model = { ...this.model, files: value } }
            },

            variants: {
                get() { return this.model.variants },
                set(value) { this.model = { ...this.model, variants: value } }
            }
        },

        created() {
            this.$scrollTo('body')

            // Aktive Variante setzen
            this.activeVariant = this.variants[0]
        },

        data() {
            return {
                activeVariantNumber: 1
            }
        },

        methods: {

            back() {
                this.$router.push({ name: 'products/create' })
            },

            onUploaded({ fileModel }) {
                const productFileModel = {
                    file: fileModel.id,
                    type: 'SKETCH'
                }

                this.productFileModels = R.append(productFileModel, this.productFileModels)
                //this.$store.dispatch('productFiles/create', { model: productFileModel })
            },

            setActiveVariant(variantNumber) {
                this.activeVariantNumber = variantNumber
            },

            submit() {
                // Embedded-Forms als "submitted" markieren
                this.$refs.generalInformation.$v.$touch()
                this.$refs.printingsForm.$v.$touch()
                this.$refs.variantForm.$touch()

                // Pruefen ob alle Formular valide sind
                if (this.isInvalid) {
                    this.$scrollToAndFocus('.field.error')
                    return
                }

                // Auf zu Step 3!
                this.$router.push({
                    name: 'products/create/step3',
                    params: this.$route.params
                })
            }

        }

    }

</script>


